// Mirrors paved-frontend `shared-components/src/utils/index.ts` so demo / lead
// forms reject personal mailbox providers when an advertiser signs up.
export const FORBIDDEN_EMAIL_DOMAINS: string[] = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'mail.ru',
  'bk.ru',
  'inbox.ru',
  'list.ru',
  'yandex.ru',
  'aol.com',
  'icloud.com',
  'protonmail.com',
  'me.com',
  'proton.me',
  'tutanota.com',
  'mailinator.com',
  'dispostable.com',
  'tempmail.com',
  '10minutemail.com',
  'guerrillamail.com',
  'yopmail.com',
  'live.com',
  'hey.com',
  'hotmail.co.uk',
  'gmx.de',
  'gmx.com',
  'gmx.net',
  'mail.com',
  'email.com',
  'europe.com',
  'usa.com',
  'consultant.com',
  'zoho.com',
  'msn.com',
  'shaw.ca',
  'sympatico.ca',
  'rogers.com',
  'comcast.net',
  'sbcglobal.net',
  'verizon.net',
  'att.net',
  'cox.net',
  'bellsouth.net',
  'charter.net',
  'earthlink.net',
  'optonline.net',
  'juno.com',
  'yahoo.co.uk',
  'rocketmail.com',
  'btinternet.com',
  'fastmail.com',
  'pm.me',
  'web.de',
  't-online.de',
  'laposte.net',
  'free.fr',
  'sfr.fr',
  'orange.fr',
  'libero.it',
  'alice.it',
  'tiscali.it',
  'virgilio.it',
  'rambler.ru',
  'freenet.de',
  'bigpond.com',
  'sky.com',
  'ntlworld.com',
  'blueyonder.co.uk',
  'bluewin.ch',
  'skynet.be',
  'telenet.be',
  'hetnet.nl',
  'zonnet.nl',
  'planet.nl',
  'chello.nl',
  'ymail.com',
  'googlemail.com',
  'rediffmail.com',
  'uol.com.br',
  'bol.com.br',
  'ig.com.br',
  'terra.com.br',
]

export const isCompanyEmail = (value: string | undefined): boolean => {
  const domain = value?.split('@')[1] ?? ''
  return !FORBIDDEN_EMAIL_DOMAINS.includes(domain.toLowerCase())
}
